import { CloseIcon, Header, IconButton, Paragraph } from "@datagame/ui";
import { Dialog } from "@headlessui/react";
import { useTranslation } from "react-i18next";

import { Content } from "../../../reports/ReportView/ShareSection/Content";
import { ProjectForReport } from "../../../reports/ReportView/ReportView";

import styles from "./ShareReportModal.module.scss";

interface ShareReportModalProps {
  onClose: () => void;
  project: ProjectForReport;
}

export const ShareReportModal = ({ onClose, project }: ShareReportModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={true} onClose={onClose}>
      <div className={styles.overlay} />
      <Dialog.Panel>
        <div className={styles.modal}>
          <div className={styles.headerWrapper}>
            <Header className={styles.header} variant="h6">
              {t("report:shareOptions")}
            </Header>
            <IconButton size="small" onClick={onClose} className={styles.close} icon={<CloseIcon />} />
          </div>
          <Paragraph color="secondary" size="small" className={styles.description}>
            {t("report:shareOptionsDescription")}
          </Paragraph>
          <Content project={project} />
        </div>
      </Dialog.Panel>
    </Dialog>
  );
};
